import script from "./ServiceDetailModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ServiceDetailModal.vue?vue&type=script&setup=true&lang=js"

import "./ServiceDetailModal.vue?vue&type=style&index=0&id=5662c870&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5662c870"]])

export default __exports__